// router
import { Router } from "routes/router";
// providers
import {
  NotificationProvider,
  ThemeContextProvider,
  MuiProvider,
  AuthProvider,
  HelmetContextProvider,
  // FirebaseProvider,
} from "providers";
import { I18nextProvider } from "react-i18next";
import { QueryParamProvider } from "use-query-params";
import { Provider } from "react-redux";
// configs
import { store } from "features/redux/redux-store";
import i18n from "./i18n/i18-config";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";
import MotionLazyContainer from "components/common/Animation/MotionLazyContainer";
// styles
// import "simplebar/dist/simplebar.css";
import "simplebar-react/dist/simplebar.min.css";
import "keen-slider/keen-slider.min.css";
import { ScrollToTop } from "components/common/ScrollToTop";

function App() {
  return (
    <HelmetContextProvider>
      <NotificationProvider>
        <ThemeContextProvider>
          <MuiProvider>
            <Provider store={store}>
              <AuthProvider>
                <QueryParamProvider adapter={ReactRouter6Adapter}>
                  <I18nextProvider i18n={i18n} defaultNS={"translation"}>
                    <ScrollToTop />
                    {/* <Firebase /> */}
                    {/* <FirebaseProvider> */}
                    <MotionLazyContainer>
                      <Router />
                    </MotionLazyContainer>
                    {/* </FirebaseProvider> */}
                  </I18nextProvider>
                </QueryParamProvider>
              </AuthProvider>
            </Provider>
          </MuiProvider>
        </ThemeContextProvider>
      </NotificationProvider>
    </HelmetContextProvider>
  );
}

export default App;

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/najva-messaging-sw.js")
    .then(function (registration) {
      console.log("Registration successful, scope is:", registration.scope);
    })
    .catch(function (err) {
      console.log("Service worker registration failed, error:", err);
    });
}
